export default {
  settings: {
    title: '設定',
    account_related: '帳號相關',
    user_related: '使用者相關',
    add_user_title: '新增使用者',
    edit_user_title: '編輯使用者',
    label: {
      enabled: '有',
      not_set: '未設定',
    },
    company: {
      title: '公司資訊',
      name: '公司名稱',
      english_name: 'English name',
      scale: '員工人數',
      industry_type: '業種',
      plan: '方案',
      location: '地址',
      allowed_ip: 'IP位址限制',
      mfa: 'SMS驗證',
      sales_amount: '營業額',
      country: '國家',
    },
    contract_plans: {
      buyer: '買家方案',
      supplier: '供應商方案',
    },
    user: {
      title: '使用者一覽',
      name: '姓名',
      first_name: '名',
      last_name: '姓',
      email: '電子郵件地址',
      email_unverified: '開通前',
      password: '密碼',
      password_protection: '基於安全理由不會顯示',
      phone_number: '電話號碼',
      role: {
        title: '權限',
        admin: '管理者',
        general: '一般',
      },
      locale: '選擇語言',
      action: '操作',
      total: '全部{total}筆 (最多{max}筆)',
    },
    button: {
      create: '增加使用者',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【注意】',
    cautions_01: '無法變更電子信箱。若要重新設定電子信箱，請重新建立使用者。',
    cautions_02: '若已設定SMS驗證，則必須輸入電話號碼。',
    cautions_03: '欲重設密碼時，請在重設密碼畫面中，輸入發送至您登錄之電子郵件地址的確認代碼',
    cautions_04: '刪除使用者後，仍不會刪除已回覆的資料或分數卡。',
    messages: {
      user_update: '更新使用者資訊',
      user_delete: '刪除使用者',
      confirm_delete: '您要刪除此使用者嗎？',
      complete_create: '使用者資訊已增加完成。',
      complete_update: '使用者資訊已更新完成。',
      complete_delete: '使用者資訊已刪除完成。',
      disabled_delete: '由於無管理人，故無法刪除',
      disabled_delete_by_auth: '僅限管理人可以刪除',
      invalid_form: '輸入內容不齊全。',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: '點擊「新增」後，系統將發送確認郵件到您輸入的電子郵件地址。\n之後將發送含有登入ID和密碼的郵件。',
      caution_two: '若已設定SMS驗證，則必須輸入電話號碼。',
      caution_three: '最多可新增5位使用者。',
      user_add_title: '@:settings.button.create',
      user_add_message_one: '我們已發送郵件至您輸入的電子郵件地址。',
      user_add_message_two: '請確認後，依照郵件內容登入。',
    },
    tips: {
      role: '「管理者」權限可新增或刪除使用者，「一般」權限則無此功能。',
      locale: '登入後可在初始設定中選擇顯示的語言。',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: '是否登出，並移動至重設密碼畫面？請在重設密碼畫面中，輸入發送至您登錄電子郵件地址的郵件中所記載的確認代碼。',
      reset: '重設',
    },
  },
}
